const data = [
    {
        "id": "01",
        "city": "San Francisco",
        "state": "CA",
        "date": "03/27",
        "day_of_wk": "Sat",
        "location": "Saratoga City Hall",
        "location_link": "https://maps.google.com/?q=Saratoga City Hall",
        "time": "11:00am",
        "year": "2021"
    },
    {
        "id": "02",
        "city": "Chicago",
        "state": "IL",
        "date": "03/27",
        "day_of_wk": "Sat",
        "location": "2100 S Wentworth Ave",
        "location_link": "https://maps.google.com/?q=2100 S Wentworth Ave, Chicago",
        "time": "2:00pm",
        "year": "2021"
    },
    {
        "id": "03",
        "city": "Princeton",
        "state": "NJ",
        "date": "03/27",
        "day_of_wk": "Sat",
        "location": "Palmer Square ",
        "location_link": "https://maps.google.com/?q=Palmer Square ",
        "time": "1:00PM",
        "year": "2021"
    },
    {
        "id": "04",
        "city": "Flushing",
        "state": "NY",
        "date": "03/27",
        "day_of_wk": "Sat",
        "location": "41-17 Main ST",
        "location_link": "https://maps.google.com/?q=41-17 Main st.",
        "time": "1:00PM",
        "year": "2021"
    },
    {
        "id": "05",
        "city": "Phoenix",
        "state": "AZ",
        "date": "03/27",
        "day_of_wk": "Sat",
        "location": "Wesley Bolin Memorial Park",
        "location_link": "https://maps.google.com/?q=Wesley Bolin Memorial Park @ 1690 W Jefferson St, Phoenix AZ, 85007",
        "time": "10:00AM",
        "year": "2021"
    },
    {
        "id": "06",
        "city": "Montreal",
        "state": "MON",
        "date": "03/21",
        "day_of_wk": "Sun",
        "location": "Cabot Square, Shaughnessy Village",
        "location_link": "https://maps.google.com/?q=Cabot Square, Shaughnessy Village, Ville-Marie Montreal",
        "time": "12:50pm",
        "year": "2021"
    },
    {
        "id": "07",
        "city": "Dallas",
        "state": "TX",
        "date": "03/21",
        "day_of_wk": "Sun",
        "location": "400 Elm St. Dallas",
        "location_link": "https://maps.google.com/?q=400 Elm St. Dallas",
        "time": "7:00pm",
        "year": "2021"
    },
    {
        "id": "08",
        "city": "Chandler",
        "state": "AZ",
        "date": "03/21",
        "day_of_wk": "Sun",
        "location": "Chandler City Hall",
        "location_link": "https://maps.google.com/?q=Chandler City Hall front floor @ 175 S Arizona Ave, Chandler, AZ 85225",
        "time": "6:00PM",
        "year": "2021"
    },
    {
        "id": "09",
        "city": "Portland",
        "state": "OR",
        "date": "03/20",
        "day_of_wk": "Sat",
        "location": "Waterfront Park at Salmon St and Natio Pkwy",
        "location_link": "https://maps.google.com/?q=Waterfront Park at Salmon St and Natio Pkwy",
        "time": "6:00pm",
        "year": "2021"
    },
    {
        "id": "10",
        "city": "Gainesville",
        "state": "FL",
        "date": "03/20",
        "day_of_wk": "Sat",
        "location": "The Turlington Plaza on UF Campus",
        "location_link": "https://maps.google.com/?q=The Turlington Plaza (by the Century Tower) on UF campus",
        "time": "7:30pm",
        "year": "2021"
    }
];

export default data;
